import { axios } from '~/common/utils/request'
const commonPath = 'rest/store/general/v3/' // 服务域
const productUrl = 'rest/portal/product/v3/'  // 产品域
const nodePath = 'nodeapi/service-strapi/' // 打印模板api
const frontCommonPath = 'rest/store/logistics/v3/' // 物流基础数据api
const orderPath = 'rest/store/order/v3/' // 订单域

// 获取模板选项
export const getTemplates = params => axios({
  url: `${commonPath}service_templates/select`,
  method: 'post',
  data: params
})

// 获取模板HTML
export const getPrintHtml = params => axios({
  url: `${nodePath}template/viewhtml`,
  method: 'get',
  data: params
})

// 产品建议搜索
export const spuSuggest = params => axios({
  url: `${productUrl}spus/suggest`,
  method: 'post',
  data: params
})

// 配送产品查询
export const getAllotmentSpu = params => axios({
  url: `${productUrl}peisongspus/query`,
  method: 'post',
  data: params
})

// 服务项列表
export const getServiceLineList = params => axios({
  url: `${orderPath}logistics-service-line-items/search`,
  method: 'post',
  data: params
})

// 创建物流服务单
export const createServiceOrders = params => axios({
  url: `${orderPath}service-orders/logistics`,
  method: 'post',
  data: params
})

// 物流服务项创建履约
export const fulfillmentServiceLine = params => axios({
  url: `${orderPath}logistics-service-line-items/fulfillment`,
  method: 'post',
  data: params
})

// 前台存货项列表
export const getFrontStockList = params => axios({
  url: `${frontCommonPath}stock/stock_list`,
  method: 'post',
  data: params
})

// 前台仓库列表
// export const getFrontWarehouseList = params => axios({
//   url: `${frontCommonPath}warehouse/list`,
//   method: 'post',
//   data: params
// })

// 前台库区列表
export const getFrontSectionList = params => axios({
  url: `${frontCommonPath}section/list`,
  method: 'post',
  data: params
})

// 前台库位列表
export const getFrontLotList = params => axios({
  url: `${frontCommonPath}lot/list`,
  method: 'post',
  data: params
})

// 前台存货项库位
export const getStockLotList = params => axios({
  url: `${frontCommonPath}stock/lot/list`,
  method: 'post',
  data: params
})

// 前台品检规则列表
export const getFrontQcRuleList = params => axios({
  url: `${frontCommonPath}qc_rule/list`,
  method: 'post',
  data: params
})

// 前台品检类型列表
export const getFrontQcCategoryList = params => axios({
  url: `${frontCommonPath}qc_categ/list`,
  method: 'post',
  data: params
})

// 前台品检类型列表
export const getFrontEquipmentList = params => axios({
  url: `${frontCommonPath}qc_equipent/list`,
  method: 'post',
  data: params
})

// 前台运单列表
export const getFrontWaybillList = params => axios({
  url: `${frontCommonPath}waybill/list`,
  method: 'post',
  data: params
})

// 前台关单列表
export const getFrontTariffList = params => axios({
  url: `${frontCommonPath}tariff/list`,
  method: 'post',
  data: params
})

// 前台关单项列表
export const getFrontTariffLineList = params => axios({
  url: `${frontCommonPath}tariff_line/list`,
  method: 'post',
  data: params
})

// 前台配收
export const getFrontReceiveOrderList = params => axios({
  url: `${frontCommonPath}order/receiver/list`,
  method: 'post',
  data: params
})

// 前台配发
export const getFrontSendOrderList = params => axios({
  url: `${frontCommonPath}order/send/list`,
  method: 'post',
  data: params
})

// 前台母单详情
export const geFrontOrderInfo = id => axios({
  url: `${frontCommonPath}order/list/${id}`,
  method: 'get'
})

// 前台配收配送撤回
export const orderCancel = id => axios({
  url: `${frontCommonPath}order/cancel/${id}`,
  method: 'get'
})

// 前台母单项列表
export const getFrontOrderLineList = params => axios({
  url: `${frontCommonPath}order/line_list`,
  method: 'post',
  data: params
})
